import SortTilesDesc from './SortTilesDesc'

export default SortTilesDesc
// eslint-disable-next-line import/export
export * from './SortTilesDesc'
